export default __webpack_public_path__ + "static/media/logo.24d91b94.svg";